import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { scrollToPurchase } from '../utils/scroll';
export function Hero() {
  const [showImage, setShowImage] = useState(false);
  useEffect(() => {
    // Defer image load so text becomes LCP instead of the heavy 1MB image
    const timer = requestAnimationFrame(() => {
      setShowImage(true);
    });
    return () => cancelAnimationFrame(timer);
  }, []);
  return <section className="relative overflow-hidden bg-brand-black px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-69">
      <div className="relative mx-auto max-w-4xl text-center" data-id="element-70">
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-brand-green/30 bg-brand-green/10 px-4 py-1.5 text-sm font-medium text-brand-green" data-id="element-71">
          <span className="h-2 w-2 rounded-full bg-brand-green animate-pulse" data-id="element-72"></span>
          MÉTODO DIGITAL · ACCESO INMEDIATO
        </div>

        <h1 className="mb-4 text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-73">
          Cierre Maestro 2.0
        </h1>
        <p className="mb-6 text-2xl font-bold text-brand-green sm:text-3xl lg:text-4xl" data-id="element-74">
          El Sistema de Ventas por WhatsApp
        </p>
        <h2 className="mb-8 text-3xl font-bold tracking-tight text-gray-300 sm:text-4xl lg:text-5xl" data-id="element-75">
          <span className="block" data-id="element-76">Dejas de Perseguir Clientes.</span>
          <span className="block mt-2" data-id="element-77">Empiezas a Cerrar Conversaciones.</span>
        </h2>

        {/* Product Image - deferred to avoid being LCP */}
        {showImage && <div className="mx-auto my-12 max-w-lg cursor-pointer" onClick={scrollToPurchase} role="button" tabIndex={0} aria-label="Ver oferta de CIERRE 2.0" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/xp5A42Lw51WL26ZntjH2T6/ChatGPT_Image_26_mar_2026,_12_07_19.png" alt="Mockup del sistema CIERRE 2.0 en iPad y iPhone" className="w-full rounded-2xl border border-white/10" width="662" height="441" loading="eager" data-id="element-79" />
          </div>}

        <p className="mx-auto mb-10 max-w-2xl text-xl text-gray-300 sm:text-2xl leading-relaxed" data-id="element-80">
          El sistema de 5 tomos que convierte tus chats de WhatsApp en
          transacciones reales — sin presionar, sin scripts robóticos y sin
          sonar desesperado.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-81">
          <CTAButton className="text-xl px-10 py-5" data-id="element-82">
            QUIERO EL SISTEMA POR $13.99
          </CTAButton>
          <p className="text-sm text-gray-400 flex items-center gap-2" data-id="element-83">
            <span className="text-brand-green" data-id="element-84">⚡</span> Acceso inmediato tras
            el pago · Formato PDF · Sin suscripciones
          </p>
        </div>
      </div>
    </section>;
}